export default __webpack_public_path__ + "static/media/PancardIcon.0bccfc8c.png";